import React, { useState } from 'react';
import { Container, Card, CardBody, Button, Alert } from 'reactstrap';
import Breadcrumb from '../../../Components/UI/Breadcrumb';
import Dropzone from "react-dropzone";
import { createProductCSV } from 'helpers/API Calls/Operations/Products';

function UploadCSV() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string[]>([]);

  const handleDownloadSample = () => {
    const link = document.createElement('a');
    link.href = '/products_sample.csv';
    link.download = 'products_sample.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAcceptedFiles = (files: File[]) => {
    const file = files[0];
    if (file && file.name.endsWith('.csv')) {
      setSelectedFile(file);
      setError([]);
    } else {
      setError(['Please upload a valid CSV file']);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError(['Please select a CSV file to upload']);
      return;
    }

    if (!selectedFile.name.endsWith('.csv')) {
      setError(['Please upload a valid CSV file']);
      return;
    }

    setIsUploading(true);
    setError([]);

    try {
      const response = await createProductCSV(selectedFile)
      if (response) {
        if (response.error && Array.isArray(response.error.messages)) {
          setError(response.error.messages);
        } else {
          setError([response.message || 'Error uploading file']);
        }
        return;
      }
      setSelectedFile(null);
    } catch (err: any) {
      setError([err.message || 'Failed to upload products']);
    } finally {
      setIsUploading(false);
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Products", link: "/products" }, { label: 'Upload CSV' }]} />
        <Card>
          <CardBody>
            <div className="mb-4">
              <h4>Upload Products CSV</h4>
              <p className="text-muted">
                Upload your products using a CSV file. Please make sure your CSV file follows the correct format.
                You can download a sample CSV file to see the required format.
              </p>
              <Button
                color="info"
                className="my-4"
                onClick={handleDownloadSample}
              >
                Download Sample CSV
              </Button>
            </div>

            <div className="mb-4">
              <Dropzone
                accept={{
                  'text/csv': ['.csv'],
                  'application/vnd.ms-excel': ['.csv']
                }}
                multiple={false}
                onDrop={handleAcceptedFiles}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div className="dz-message needsclick mt-2" {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div className="mb-3">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                      </div>
                      <h4>Drop CSV file here or click to upload.</h4>
                      {selectedFile && (
                        <div className="mt-3">
                          <h5 className="text-success">Selected file: {selectedFile.name}</h5>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>

            {error.length > 0 && (
                <>
                    {error.map((errMsg, index) => (
                        <Alert color="info" className="mb-4" key={index}>
                            {errMsg}
                        </Alert>
                    ))}
                </>
            )}

            <div className="text-end">
              <Button
                color="primary"
                onClick={handleUpload}
                disabled={!selectedFile || isUploading}
              >
                {isUploading ? 'Uploading...' : 'Upload Products'}
              </Button>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}

export default UploadCSV;
